var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:( _obj = {'badge-state': true}, _obj[_vm.bg] = true, _obj )},[(_vm.icon)?_c('i',{staticClass:"icon",class:( _obj$1 = {}, _obj$1[_vm.icon] = true, _obj$1['mr-5'] =  !!_vm.msg, _obj$1 )}):_vm._e(),_vm._v(_vm._s(_vm.msg)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }